import { EnvService } from '../env.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../env.service";
export class PurchaseService {
    constructor(http, envService) {
        this.http = http;
        this.envService = envService;
        this.apiUrl = '';
        this.apiUrl = envService.API_URL;
    }
    buyPromotion(data) {
        const apiUrl = this.apiUrl + `purchase/promotion/${data.promotion_id}/charge`;
        return this.http.post(apiUrl, data, { withCredentials: true });
    }
    validatePromoCode(promocode, promotionId) {
        const apiUrl = this.apiUrl + `promocodes/${promocode}/${promotionId}/apply`;
        return this.http.get(apiUrl);
    }
    buyStudioTermPlan(venueid, data) {
        const apiUrl = this.apiUrl + 'purchase/spaces/' + venueid + '/charge';
        return this.http.post(apiUrl, data, { withCredentials: true });
    }
}
PurchaseService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PurchaseService_Factory() { return new PurchaseService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvService)); }, token: PurchaseService, providedIn: "root" });
